<lms-list
  [listId]="listId"
  [serviceProvider]="documentsService"
  (collectionUpdated)="setCollection($event)"
  [options]="listOptions"
>
  <div class="table-heading">
    <lms-list-header [listId]="listId" class="table-item" field="client" label="nouns.name"></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item hide-on-med-and-down"
      field="clientName"
      label="nouns.client"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item hide-on-med-and-down"
      field="type"
      label="nouns.type"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item hide-on-med-and-down"
      field="created_at"
      label="nouns.createdDate"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item hide-on-med-and-down"
      field="numQuestions"
      label="nouns.numQuestions"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item hide-on-med-and-down"
      field="numCustomizations"
      label="nouns.numCustomizations"
    ></lms-list-header>
    <div class="table-item"></div>
  </div>
  <lms-documents-list-row *ngFor="let document of documents" [document]="document">
    <gl-button
      icon
      icon-center="glicon-trash"
      (onClick)="deleteDocument(document)"
      *lmsProfileGuard="'documents.delete'"
      class="right"
      title="{{ 'actions.delete' | translate }}"
      row-actions
    >
    </gl-button>
  </lms-documents-list-row>
</lms-list>
